/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!********************************************!*\
  !*** ./src/assets/js/custom-collection.js ***!
  \********************************************/
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('store-header') && document.querySelectorAll('.top_plp_menus').length > 0 && document.querySelectorAll('.grid-anchor').length > 0) {
    var storeHeader = document.querySelector('store-header');
    var topPlpMenus = document.querySelectorAll('.top_plp_menus'); // Select both mobile and desktop elements
    var gridAnchors = document.querySelectorAll('.grid-anchor');
    var storeHeaderHeight = storeHeader.offsetHeight;
    topPlpMenus.forEach(function (topPlpMenu) {
      // Adjust the position only for desktop menu by checking if contains "desktop-menu" class
      /*if (topPlpMenu.classList.contains('desktop-menu')) {
        topPlpMenu.style.top = `0px`;
      }*/

      window.addEventListener('scroll', function () {
        if (window.scrollY > 600) {
          topPlpMenu.classList.add('scrolled');
        } else {
          topPlpMenu.classList.remove('scrolled');
        }
        gridAnchors.forEach(function (gridAnchor) {
          var gridAnchorId = gridAnchor.id;
          var navItem = topPlpMenu.querySelector("a[href=\"#".concat(gridAnchorId, "\"]"));
          var navItemsArray = topPlpMenu.querySelectorAll('.scrolltobtn');
          if (gridAnchor.getBoundingClientRect().top < 600) {
            navItemsArray.forEach(function (navItem) {
              navItem.classList.remove('active');
            });
            if (navItem) navItem.classList.add('active');
          } else if (window.scrollY === 0 && navItem) {
            navItem.classList.remove('active');
          }
        });
      });
    });
  }
});
/******/ })()
;